module.exports = __webpack_public_path__ + "img/bicycleRearLeftOutline.bfb1d374.svg";